import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs';
import { ListaPrecioCabecera } from '../models/listaPrecioCabecera';
import { ListaPrecioItem } from '../models/listaPrecioItem';
import { Producto } from '../models/producto';
import { CuotaPlanta } from '../models/cuotaPlanta';
import { CuotaDistribuidor } from '../models/cuotaDistribuidor';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {

  private productosServerUri: string;
  private apiUrl = environment.apiUrl;

  constructor(private configService: ConfigService, private dialog: MatDialog, private httpCliente: HttpClient,private tokenService: TokenService) {
    this.productosServerUri = this.apiUrl + '/' + this.configService.ProductosURI;
  }

  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  cListasPreciosCabeceras(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CListasPreciosCabeceras?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  cListaPrecioCabeceraDB(codigo: number) {
    return this.httpCliente.get(this.productosServerUri + 'CListaPrecioCabeceraDB?codigo=' + codigo, { headers: this.getHeaders() });
  }
  cListaPrecioCabecera(idPais: string, idCompania: string, idSalesOrg: string, id: string) {
    return this.httpCliente.get(this.productosServerUri + 'CListaPrecioCabecera?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&id=" + id, { headers: this.getHeaders() });
  }

  aListaPrecioCabecera(model: ListaPrecioCabecera) {
    return this.httpCliente.post(this.productosServerUri + 'AListaPrecioCabecera', model, { headers: this.getHeaders() });
  }

  mListaPrecioCabecera(model: ListaPrecioCabecera) {
    return this.httpCliente.post(this.productosServerUri + 'MListaPrecioCabecera', model, { headers: this.getHeaders() });
  }

  bListaPrecioCabecera(model: ListaPrecioCabecera) {
    return this.httpCliente.delete(this.productosServerUri + 'BListaPrecioCabecera?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  cListaPrecioItems(idPais: string, idCompania: string, idSalesOrg: string, idListaPrecios: string, idTerminoPago: string) {
    return this.httpCliente.get(this.productosServerUri + 'CListaPrecioItems?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idListaPrecios=" + idListaPrecios + "&idTerminoPago=" + idTerminoPago, { headers: this.getHeaders() });
  }

  cListaPrecioItemDb(codigo: number) {
    return this.httpCliente.get(this.productosServerUri + 'CListaPrecioItemDb?codigo=' + codigo, { headers: this.getHeaders() });
  }

  mListaPrecioItem(model: ListaPrecioItem) {
    return this.httpCliente.post(this.productosServerUri + 'MListaPrecioItem', model, { headers: this.getHeaders() });
  }

  bListaPrecioItem(model: ListaPrecioItem) {
    return this.httpCliente.delete(this.productosServerUri + 'BListaPrecioItem?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  cProductos(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CProductos?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  cProductoDB(codigo: number) {
    return this.httpCliente.get(this.productosServerUri + 'CProductoDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  mProducto(model: Producto) {
    return this.httpCliente.post(this.productosServerUri + 'MProducto', model, { headers: this.getHeaders() });
  }

  cDepositos(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CDepositos?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  cDepositoProductos(idPais: string, idCompania: string, idSalesOrg: string, idPlanta: string, idUbicacionAlmacenamiento: string, nroCliente: string, nroClienteDireccion: string, idProducto: string) {
    return this.httpCliente.get(this.productosServerUri + 'cDepositoProductos?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&nroCliente=" + nroCliente + "&nroClienteDireccion=" + nroClienteDireccion + "&idProducto=" + idProducto, { headers: this.getHeaders() });
  }

  cDepositoProductosPorLote(idPais: string, idCompania: string, idSalesOrg: string, idPlanta: string, idUbicacionAlmacenamiento: string, nroCliente: string, nroClienteDireccion: string, idProducto: string) {
    return this.httpCliente.get(this.productosServerUri + 'cDepositoProductosPorLote?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&nroCliente=" + nroCliente + "&nroClienteDireccion=" + nroClienteDireccion + "&idProducto=" + idProducto, { headers: this.getHeaders() });
  }

  cDistribuidoresAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, search: string) {
    return this.httpCliente.get(this.productosServerUri + 'CDistribuidoresAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&search=" + search, { headers: this.getHeaders() });
  }

  cDireccionesDistribuidor(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, nroClientePartner: string) {
    return this.httpCliente.get(this.productosServerUri + 'CDireccionesDistribuidor?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&nroClientePartner=" + nroClientePartner, { headers: this.getHeaders() });
  }

  cCuotasPlantas(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CCuotasPlantas?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  bCuotaPlanta(model: CuotaPlanta) {
    return this.httpCliente.delete(this.productosServerUri + 'BCuotaPlanta?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  cCuotaPlantaDB(codigo: number) {
    return this.httpCliente.get(this.productosServerUri + 'CCuotaPlantaDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  cStoragesLocationsPlanta(idPais: string, idCompania: string, idSalesOrg: string, idPlanta) {
    return this.httpCliente.get(this.productosServerUri + 'CStoragesLocationsPlanta?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idPlanta=" + idPlanta, { headers: this.getHeaders() });
  }

  cProductosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, search: string) {
    return this.httpCliente.get(this.productosServerUri + 'CProductosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&search=" + search, { headers: this.getHeaders() });
  }

  aCuotaPlanta(model: CuotaPlanta) {
    return this.httpCliente.post(this.productosServerUri + 'ACuotaPlanta', model, { headers: this.getHeaders() });
  }

  mCuotaPlanta(model: CuotaPlanta) {
    return this.httpCliente.post(this.productosServerUri + 'MCuotaPlanta', model, { headers: this.getHeaders() });
  }

  cCuotasDistribuidores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CCuotasDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  bCuotaDistribuidor(model: CuotaDistribuidor) {
    return this.httpCliente.delete(this.productosServerUri + 'BCuotaDistribuidor?codigo=' + model.codigo, { headers: this.getHeaders() });
  }

  cCuotaDistribuidorDB(codigo: number) {
    return this.httpCliente.get(this.productosServerUri + 'CCuotaDistribuidorDB?codigo=' + codigo, { headers: this.getHeaders() });
  }

  aCuotaDistribuidor(model: CuotaDistribuidor) {
    return this.httpCliente.post(this.productosServerUri + 'ACuotaDistribuidor', model, { headers: this.getHeaders() });
  }

  mCuotaDistribuidor(model: CuotaDistribuidor) {
    return this.httpCliente.post(this.productosServerUri + 'MCuotaDistribuidor', model, { headers: this.getHeaders() });
  }

  CDistribuidores(idPais: string, idCompania: string, idSalesOrg: string) {
    return this.httpCliente.get(this.productosServerUri + 'CDistribuidores?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg, { headers: this.getHeaders() });
  }

  aCuotasDistribuidoresExcel(form: FormData) {
    return this.httpCliente.post(this.productosServerUri + 'ACuotasDistribuidoresExcel', form, {
      observe: 'response',
      responseType: 'blob' as 'json',
      headers: this.getHeaders()
    });
  }

  aCuotasPlantasExcel(form: FormData) {
    return this.httpCliente.post(this.productosServerUri + 'ACuotasPlantasExcel', form, {
      observe: 'response',
      responseType: 'blob' as 'json',
      headers: this.getHeaders()
    });
  }
}
